import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { UserState } from 'types/global';
import { subscribe, unsubscribe, configure } from '../utils/pusher';

const usePusher = () => {
  const user = useSelector<any, UserState>(state => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    const pusher = configure(user);
    const channelName = subscribe(pusher, user, dispatch);

    return () => {
      unsubscribe(pusher, channelName);
    };
  }, [user, dispatch]);

  return user;
};

export default usePusher;
